import header from "./factsheet.png";
import section1 from "./grundriss-auf-tablet.png";
import section2 from "./expose.webp";
import section3 from "./neubauprojekt.webp";

export { header, section1, section2, section3 };
